// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6mTLu","cover":"styles_cover__X89CY","song":"styles_song__5QOGZ","artist":"styles_artist__FtTp6","skeleton_animate":"styles_skeleton_animate__A68Si"};